module.exports = __webpack_public_path__ + "static/media/Search.bbd21e3e.svg";